module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Join-1-7769e5cdd863fd6160a546854c20eb7a.svg";